<template>
  <div id="note" class="pdt-10 white">
    <v-container>
      <div
        class="text-center primary--text font-weight-bold"
        data-aos="fade-up"
        :class="MIXIN_SETUP_UI.header"
      >
        Note the following:
      </div>

      <v-row justify="center">
        <v-col
          cols="12"
          class="mt-5"
          :class="[ { 'pdx-20': MIXIN_SETUP_UI.show } ]"
        >
          <ol>
            <li
              class="pb-3"
              v-for="(note, key) in notes"
              :key="key"
              data-aos="fade-up"
            >{{ note }}</li>
          </ol>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "NotesOrderedList",
    props: {
      notes: { type: Array }
    }
  }
</script>

<style lang="scss" scoped>

</style>